import { useState } from 'react';

export default function StarRating({ value = 0, count, size = 16, interactive = false, onChange }) {
  const [hover, setHover] = useState(0);
  const display = interactive ? hover || value : value;
  return (
    <span
      data-testid={interactive ? 'rating-input' : undefined}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
      role={interactive ? 'radiogroup' : undefined}
      aria-label="Rating"
    >
      <span style={{ display: 'inline-flex', gap: 2 }}>
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            data-testid={interactive ? `rating-star-${i}` : undefined}
            onClick={() => interactive && onChange && onChange(i)}
            onMouseEnter={() => interactive && setHover(i)}
            onMouseLeave={() => interactive && setHover(0)}
            disabled={!interactive}
            aria-label={`${i} star${i > 1 ? 's' : ''}`}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              fontSize: size,
              cursor: interactive ? 'pointer' : 'default',
              color: i <= Math.round(display) ? '#F59E0B' : '#E2E8F0',
              transition: 'color .12s ease, transform .12s ease',
              transform: interactive && hover === i ? 'scale(1.15)' : 'none',
              lineHeight: 1,
            }}
          >
            ★
          </button>
        ))}
      </span>
      {value > 0 && !interactive && (
        <span style={{ fontSize: Math.max(11, size - 4), color: '#64748B', fontWeight: 700 }}>
          {value.toFixed(1)}
          {typeof count === 'number' && (
            <span style={{ color: '#94A3B8', fontWeight: 500 }}> ({count})</span>
          )}
        </span>
      )}
      {value === 0 && typeof count === 'number' && count === 0 && !interactive && (
        <span style={{ fontSize: Math.max(11, size - 4), color: '#94A3B8' }}>No reviews</span>
      )}
    </span>
  );
}
